export var isKeyEnterSpace = function isKeyEnterSpace(_ref) {
  var key = _ref.key;
  var SPACE_KEY = ' ';
  var ENTER_KEY = 'Enter';
  return key === SPACE_KEY || key === ENTER_KEY;
};